import {
  CsvExportDefinition,
  formatPatientDevices,
  formatUnixSecondsDateTime
} from "../../common/csvExport";

interface PatientExportRecord {
  id: string | number;
  codeName?: string;
  identifiableInfo?: { realName?: string; email?: string };
  patientAccessCreatedAt?: number;
  createdAt?: number;
  startTime?: number;
  endTime?: number;
  deviceList?: { devices?: unknown[] };
}

const dateOptions: Intl.DateTimeFormatOptions = {
  year: "numeric",
  month: "short",
  day: "numeric"
};

export const patientExportDefinition: CsvExportDefinition<PatientExportRecord> =
  {
    resource: "Patient",
    filenameStem: "organization-patients",
    id: { header: "patientID", source: "id" },
    columns: [
      {
        key: "codeName",
        label: "Code Name",
        source: "codeName",
        getValue: (r) => r.codeName
      },
      {
        key: "fullName",
        label: "Full Name",
        source: "identifiableInfo.realName",
        getValue: (r) => r.identifiableInfo?.realName
      },
      {
        key: "email",
        label: "Email",
        source: "identifiableInfo.email",
        getValue: (r) => r.identifiableInfo?.email
      },
      {
        key: "startTime",
        label: "Start Date",
        source: "startTime",
        getValue: (r) => formatUnixSecondsDateTime(r.startTime, dateOptions)
      },
      {
        key: "endTime",
        label: "End Date",
        source: "endTime",
        getValue: (r) => formatUnixSecondsDateTime(r.endTime, dateOptions)
      },
      {
        key: "added",
        label: "Added",
        source: "patientAccessCreatedAt",
        getValue: (r) =>
          formatUnixSecondsDateTime(r.patientAccessCreatedAt, dateOptions)
      },
      {
        key: "created",
        label: "Created",
        source: "createdAt",
        getValue: (r) => formatUnixSecondsDateTime(r.createdAt, dateOptions)
      },
      {
        key: "devices",
        label: "Devices",
        getValue: (r) => formatPatientDevices(r.deviceList?.devices)
      }
    ]
  };
